/**
 * Request header 関連処理
 * From: 1.0.0
 *
 * @packageDocumentation
 */

import { env } from '../../utils/EnvUtils';

const baseHeaders = (accessToken?: string | null) => ({
  Accept: 'application/json',
  'Accept-Language': 'ja',
  ...(accessToken && env.AUTH_METHOD === 'OIDC'
    ? { Authorization: `Bearer ${accessToken}` }
    : {}),
});

export const getRequestHeaders = (
  accessToken?: string | null
): HeadersInit => ({
  ...baseHeaders(accessToken),
  'Content-Type': 'application/json',
});

export const getFormDataRequestHeaders = (
  accessToken?: string | null
): HeadersInit => ({
  ...baseHeaders(accessToken),
});
